import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import  RootReducer  from '../reducers';

const loggerMiddleware = createLogger();

export const store = createStore(
    RootReducer,
    applyMiddleware(
        thunkMiddleware,
        loggerMiddleware
    )
);


// WEBPACK FOOTER //
// ./src/helpers/store.jsx